import { Link } from 'react-router-dom';
import type { IAuditEntityLinkProps } from './types.ts';
import { getAuditEntityPath } from './utils.ts';

export const AuditEntityLink: React.FC<IAuditEntityLinkProps> = (props) => {
  const { reference } = props;

  const path = getAuditEntityPath(reference);

  if (!path) return <>{reference.label}</>;

  return (
    <Link to={path} target='_blank' rel='noopener noreferrer'>
      {reference.label}
    </Link>
  );
};
